import { AsyncValidatorFn, FormControl, ValidationErrors } from '@angular/forms';
import { MsisdnService } from './msisdn.service';
import { Observable, of, timer } from 'rxjs';
import * as constants from '../../lead-generation/shared/constants/constants';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

export function createUniqueLabelValidator(msisdnService: MsisdnService, previousLabel: string): AsyncValidatorFn {
  function validate(label) {
    return msisdnService.isLabelExisting(label).pipe(
      map(response => {
        if (response.data !== null && typeof response.data === 'boolean') {
          return response.data ? { unique: true } : null;
        } else {
          return { unknownException: true };
        }
      }),
      catchError(() => {
        return of({ unknownException: true });
      })
    );
  }

  return (control: FormControl): Observable<ValidationErrors | null> => {
    let _label: string;

    function label() {
      if (_label === undefined) {
        _label = (control.value as string).trim();
      }

      return _label;
    }

    return timer(constants.debounceTime).pipe(
      filter(() => previousLabel !== label()),
      switchMap(() => validate(label()))
    );
  };
}
